import React from 'react';
import styled from 'styled-components';

/**
 * Health Check 페이지 (My-Space)
 * - 접근하기 어려운 경로에 위치
 * - 로그인 없이 접근 가능
 * - 최소한의 UI (navigation, header 없음)
 */
const HealthCheck: React.FC = () => {
  const timestamp = new Date().toISOString();
  const status = 'OK';
  const version = import.meta.env.VITE_VERSION || '1.0.0';
  const environment = import.meta.env.VITE_NODE_ENV || 'development';
  const service = 'my-space';

  return (
    <HealthCheckContainer>
      <StatusText>Status: {status}</StatusText>
      <InfoText>Service: {service}</InfoText>
      <InfoText>Timestamp: {timestamp}</InfoText>
      <InfoText>Version: {version}</InfoText>
      <InfoText>Environment: {environment}</InfoText>
      <InfoText>Uptime: {Math.floor(performance.now() / 1000)}s</InfoText>
    </HealthCheckContainer>
  );
};

const HealthCheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  background-color: #ffffff;
  font-family: monospace;
  padding: 20px;
  box-sizing: border-box;
`;

const StatusText = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #28a745;
  margin-bottom: 20px;
`;

const InfoText = styled.div`
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 8px;
`;

export default HealthCheck; 